import { connect, type ConnectedProps } from 'react-redux';

import {
  getReviewsTotal,
  getHasReviewsSection,
  getReviews,
  getHotelReviewsLink,
} from 'src/store/reviews/selectors';

import { getIsWhitelabel } from 'src/store/view/selectors';
import ReviewsSwiperContainer from './ReviewsSwiperContainer';

const mapStateToProps = (state) => ({
  hasReviewsSection: getHasReviewsSection(state),
  totalReviews: getReviewsTotal(state),
  items: getReviews(state),
  isWhiteLabel: getIsWhitelabel(state),
  hotelReviewsLink: getHotelReviewsLink(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ReviewsSwiperContainer);
